import type { CommunitySearch } from './community-search'

export type CommunityView = 'work' | 'projects' | 'discussions' | 'join' | 'search'

/** Preserve existing discussion filters and workbench deep links. */
export function communityView(
  search: CommunitySearch,
  hash = '',
): CommunityView {
  const anchor = hash.replace(/^#/, '').split('?')[0]
  if (anchor === 'workbench') return 'work'
  if (anchor === 'public-work') return 'discussions'
  if (anchor === 'community-join') return 'join'
  if (anchor === 'open-source-projects' || anchor.startsWith('challenge-'))
    return 'projects'
  if (search.view) return search.view
  return search.q || search.tag || search.kind || search.challengeId
    ? 'discussions'
    : 'work'
}
